/** Session endpoints that must keep `x-access-token` even on the public approved page. */
const ALWAYS_AUTHENTICATED_PATH_PREFIXES = ["/auth/", "/user/"];

let skipAccessToken = false;

export function setSkipAccessToken(enabled: boolean) {
	skipAccessToken = enabled;
}

function getRequestPath(url?: string) {
	if (!url) return "";
	const withoutOrigin = url.replace(/^https?:\/\/[^/]+/i, "");
	return withoutOrigin.startsWith("/") ? withoutOrigin : `/${withoutOrigin}`;
}

export function isSessionRequest(url?: string) {
	const path = getRequestPath(url);
	return ALWAYS_AUTHENTICATED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function shouldSkipAccessToken(url?: string) {
	if (!skipAccessToken) return false;
	return !isSessionRequest(url);
}
